var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-app-guest" },
    [
      _c("chat-header"),
      _vm._v(" "),
      _c("div", { staticClass: "inner" }, [
        _c(
          "form",
          { staticClass: "guest-form-wrapper", attrs: { novalidate: "" } },
          [
            _c("div", { staticClass: "guest-form" }, [
              _c("div", { staticClass: "top-text" }, [
                _vm._v(
                  "\n          👋\n          Hey, we're here to help if you have any questions or issues.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mid-text" }, [
                _vm._v(
                  "\n          Give us a little bit of information about you to get started.\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group col-sm-6 col-xs-12",
                    class: { "has-errors": _vm.errors.has("firstName") },
                  },
                  [
                    _c("form-control", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true },
                          expression: "{ required : true }",
                        },
                      ],
                      attrs: {
                        label: "First Name",
                        name: "firstName",
                        autocomplete: "given-name",
                      },
                      model: {
                        value: _vm.guestForm.firstName,
                        callback: function ($$v) {
                          _vm.$set(_vm.guestForm, "firstName", $$v)
                        },
                        expression: "guestForm.firstName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group col-sm-6 col-xs-12",
                    class: { "has-errors": _vm.errors.has("lastName") },
                  },
                  [
                    _c("form-control", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: true },
                          expression: "{ required : true }",
                        },
                      ],
                      attrs: {
                        label: "Last Name",
                        name: "lastName",
                        autocomplete: "family-name",
                      },
                      model: {
                        value: _vm.guestForm.lastName,
                        callback: function ($$v) {
                          _vm.$set(_vm.guestForm, "lastName", $$v)
                        },
                        expression: "guestForm.lastName",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group",
                  class: { "has-errors": _vm.errors.has("email") },
                },
                [
                  _c("form-control", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, email: true },
                        expression: "{ required : true, email : true }",
                      },
                    ],
                    attrs: {
                      label: "Email",
                      name: "email",
                      autocomplete: "email",
                    },
                    model: {
                      value: _vm.guestForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.guestForm, "email", $$v)
                      },
                      expression: "guestForm.email",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "account-link" },
                [
                  _vm._v("\n          or "),
                  _c(
                    "router-link",
                    { attrs: { to: { name: _vm.ROUTE_NAMES.CHAT_APP_LOGIN } } },
                    [_vm._v("Log in.")]
                  ),
                  _vm._v(" /\n          "),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: _vm.ROUTE_NAMES.CHAT_APP_LOGIN,
                          query: { signup: true },
                        },
                      },
                    },
                    [_vm._v("Sign up")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-wrapper" },
              [
                _c(
                  "btn-spinner",
                  {
                    attrs: {
                      type: "submit",
                      loading: _vm.saving,
                      "icon-right": true,
                      "class-name": "btn-primary btn-block",
                      disabled: _vm.saving,
                    },
                    on: {
                      btnClick: function ($event) {
                        _vm.updateGuest()
                      },
                    },
                  },
                  [
                    !_vm.saving
                      ? _c("span", [
                          _vm._v("\n            Start Chatting\n          "),
                        ])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/pages/Widgets/Chat/ChatAppGuest/template.html?vue&type=template&id=5275d1b5&
// module id = 1093
// module chunks = 0